package com.rosario.juridico.premium

import com.rosario.juridico.models.UserProfile
import kotlinx.browser.localStorage
import kotlinx.serialization.json.Json
import kotlinx.serialization.encodeToString
import kotlinx.serialization.decodeFromString
import kotlinx.datetime.Clock

class WebPremiumCache : PremiumCache {
    private val key = "juridico_premium_cache"
    private val syncKey = "juridico_last_sync"

    override fun save(profile: UserProfile) {
        try {
            val json = Json.encodeToString(profile)
            localStorage.setItem(key, json)
            localStorage.setItem(syncKey, Clock.System.now().toEpochMilliseconds().toString())
        } catch (e: Exception) {
            // Ignorar errores de cache
        }
    }

    override fun load(): UserProfile? {
        return try {
            val json = localStorage.getItem(key)
            if (json != null) {
                Json.decodeFromString<UserProfile>(json)
            } else {
                null
            }
        } catch (e: Exception) {
            null
        }
    }

    override fun clear() {
        try {
            localStorage.removeItem(key)
            localStorage.removeItem(syncKey)
        } catch (e: Exception) {
            // Ignorar
        }
    }
}
